import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { settlementPreviewProp } from 'src/app/interfaces/iresponse';
import { SuperAdminService } from 'src/app/services/apiCalls/superAdminService/super-admin.service';
import { UtilService } from 'src/app/services/utilService/util.service';


export interface filterSettlement{
  from?: string,
  to?: string
}
@Component({
  selector: 'app-settlement',
  templateUrl: './settlement.component.html',
  styleUrl: './settlement.component.css'
})
export class SettlementComponent implements OnInit {
  loadingSettlement:boolean = false;
  changeOccured:boolean = true;
  settlements: settlementPreviewProp[] = [];
  breadCrumb:any;
  ticketSummary = {total_ticketing: '', total_remitted: '' };
  ticketRange = {from: '', to: '' };
  constructor(private superAdminService: SuperAdminService, private utilService: UtilService){}
  filterForm = new FormGroup({
    from: new FormControl('', Validators.required),
    to: new FormControl('', Validators.required),
  })
  currentDate = new Date(Date.now()).toISOString();
  currentPage : number = 1;
  perPage: number = 10;

  ngOnInit(): void {
    this.breadCrumb  = {
      name: 'Settlement',
      parent: 'Home',
      subLink: null
    };
    this.getSettlementPreview({from: '', to: this.currentDate});
  }

  getDateRange(dateTime: string){
    const range = new Date(dateTime).toLocaleDateString('en-US', {
      month: 'long', year: 'numeric', day: 'numeric',
      hour: 'numeric', minute: 'numeric'
    })
    return range;
  }

  getSettlementPreview(filter: filterSettlement){
    this.loadingSettlement = true;
    this.changeOccured = false;
    return this.superAdminService.settlementPreview(filter, this.currentPage, this.perPage).subscribe({
      next: (response)=> {
        this.settlements = response.streams;
        const {from, to, total_ticketing, total_remitted } = response.summary;
        this.utilService.startDatatable('all-state-zones');
        this.changeOccured = true;
        this.ticketSummary.total_ticketing = total_ticketing;
        this.ticketSummary.total_remitted = total_remitted;
        this.ticketRange.from = this.getDateRange(from);
        this.ticketRange.to = this.getDateRange(to);
      }, 
      error: (err)=>{
        this.changeOccured = true;
        this.utilService.startDatatable('all-state-zones');
      }
    }).add(()=> this.loadingSettlement = false)
  }
  onFilterForm(){
    const controls = this.filterForm.value;
    this.getSettlementPreview(controls)
  }
  onReset(){
    this.filterForm.reset({
      from: '',
      to: ''
    })
  }
}
